import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import challenge from '../images/your-challenge-image.svg';
import invertase from '../images/invertase-icon.svg';

const Tab = () => {
  const tabs = [
    {
      title: "Upgrading outdated tooling systems",
      challenge:
        "Creating high-tolerance parts and tooling in-house can be costly, time-consuming, and prone to inconsistencies—especially when scaling up or entering new markets.",
      solution:
        "We deliver custom-engineered jigs, fixtures, dies, and machined components with exceptional accuracy and durability. Our expert solutions reduce lead times, improve product quality, and boost production efficiency—ensuring your operations stay ahead of demand. ",
    },
    {
      title: "Prototyping and precision component development",
      challenge:
        "Creating accurate prototypes and complex parts in early development stages often leads to delays and inconsistencies due to limited in-house capabilities or lack of precision tools",
      solution:
        "delivers fast-turnaround, high-precision prototypes and components using advanced CNC, EDM, and grinding technologies—ensuring functional accuracy from the start.",
    },
    {
      title: "Expanding into new industries ",
      challenge:
        "Entering sectors like aerospace, medical, or electronics requires meeting strict tolerance, material, and compliance standards that many manufacturers struggle to achieve.",
      solution:
        "With expertise in high-accuracy fabrication (±0.005mm) and industry-grade tooling, GXL enables seamless entry into demanding industries with confidence and compliance.",
    },
    {
      title: "Strengthening in-house manufacturing capability ",
      challenge:
        "Relying on external suppliers can limit control, delay production, and increase costs, especially for critical or custom parts. ",
      solution:
        "GXL enhances your production autonomy by supplying custom jigs, fixtures, and tooling systems tailored to your operations—improving efficiency, consistency, and flexibility.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const activeTab = tabs[activeIndex];

  return (
    <section className='bg-[#E4E5E7] lg:py-16 py-10'>
      <div className='container lg:px-10 px-6 max-w-[1600px] mx-auto'>
        <div className=''>
          <h2 className='text-gray-800 lg:text-5xl text-start text-3xl font-medium lg:max-w-[60%]'>
         When to choose GXL Precision Engineering for your manufacturing needs 
          </h2>
        </div>

        <div className="grid md:grid-cols-8 grid-cols-1 md:gap-4 gap-8 lg:mt-10 mt-6">
          {/* Tab Buttons */}
          <div className='md:col-span-3 space-y-4'>
            <ul className='m-0 space-y-6'>
              {tabs.map((tab, index) => (
                <li key={index}>
                  <button
                    onClick={() => setActiveIndex(index)}
                    className={`pl-3 text-gray-700 text-start font-semibold lg:text-2xl text-xl border-l-4 transition-all duration-300 ${activeIndex === index
                      ? "border-l-[rgb(230,145,53)]"
                      : "border-l-transparent"
                      }`}
                  >
                    {tab.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className='md:col-span-5'>
            <div className='min-h-[337px] lg:py-10 py-6 lg:px-12 px-6 rounded-[14px] bg-black solution-tab-item flex flex-col justify-between'>
              <div className='space-y-2'>
                <div className='flex items-center gap-2'>
                  <img src={challenge} alt="Challenge Icon" className="h-6 w-auto" />
                  <h3 className='text-white text-xl font-medium'>Your challenge</h3>
                </div>
                <AnimatePresence mode="wait">
                  <motion.p
                    key={activeIndex + "-challenge"}
                    className='text-[#fff]/70 text-base'
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4 }}
                  >
                    {activeTab.challenge}
                  </motion.p>
                </AnimatePresence>
              </div>

              <span className="my-6 block h-[1px] w-full bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.5)_12%,#fff_41%,#fff_59%,rgba(255,255,255,0.5)_88%,transparent_100%)] opacity-20 md:my-5"></span>

              <div className='space-y-2'>
                <div className='flex items-center gap-2'>
                  <img src={invertase} alt="Invertase Icon" className="h-6 w-auto" />
                  <h3 className='text-white text-xl font-medium'>How GXL helps</h3>
                </div>
                <AnimatePresence mode="wait">
                  <motion.p
                    key={activeIndex + "-solution"}
                    className='text-[#fff]/70 text-base'
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4 }}
                  >
                    {activeTab.solution}
                  </motion.p>
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tab;
